import React, { Component, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import PrivateRoute, { RequireService, Services } from './protectedRoutes';
import Login from '../pages/Login';
import Dashboard from '../pages/Dashboard';
import Whitelist from '../pages/Whitelist';
import Resubmissions from '../pages/Resubmissions'; 
import Ramps from '../pages/Ramps';
import IuguOnboarding from '../pages/IuguOnboarding';

class AppRoutes extends Component {
  render() {
    return (
      <BrowserRouter>
        <Suspense fallback={''}>
          <Routes>
            <Route path="/" element={<Navigate to="/login" />} />
            <Route path="/login" element={<Login />} />

            <Route path="/dashboard" element={<PrivateRoute />}>
              <Route element={<RequireService service={Services.BAAS} />}>
                <Route path="" element={<Dashboard />} />
              </Route>
            </Route>

            <Route path="/whitelist" element={<PrivateRoute />}>
              <Route element={<RequireService service={Services.BAAS} />}>
                <Route path="" element={<Whitelist />} />
              </Route>
            </Route>

            <Route path="/resubmissions" element={<PrivateRoute />}>
              <Route path="" element={<Resubmissions />} />
            </Route>

            <Route path="/ramps" element={<PrivateRoute />}>
              <Route element={<RequireService service={Services.RAMP} />}>
                <Route path="" element={<Ramps />} />
              </Route>
            </Route>

            <Route path="/iugu-onboarding" element={<PrivateRoute />}>
              <Route element={<RequireService service={Services.BAAS} />}>
                <Route path="" element={<IuguOnboarding />} />
              </Route>
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
    );
  }
}

export default AppRoutes;


